import VueRouter from 'vue-router';
import Vue from 'vue';

Vue.use(VueRouter);

export function createRouter() {
  const route = new VueRouter({
    mode: 'history',
    routes: [
      {
        name: 'login',
        path: '/login',
        meta: { name: 'login' },
        component: () => import(/* webpackChunkName: "passport" */ '@/page/passport/login.vue'),
      },
      {
        name: 'jia',
        path: '/incubation-camp',
        meta: { name: 'camp', title: '家装家居行业线上线下双导购技能训练营' },
        component: () => import(/* webpackChunkName: "jia" */ '@/page/jia/incubation-camp.vue'),
      },
      {
        name: 'jia',
        path: '/join-success',
        meta: { name: 'join-success', title: '家装家居行业线上线下双导购技能训练营' },
        component: () => import(/* webpackChunkName: "jia" */ '@/page/jia/join-success.vue'),
      },
      {
        name: 'ruan',
        path: '/ruan/apply',
        meta: { name: 'apply', title: '用户录入' },
        component: () => import(/* webpackChunkName: "ruan" */ '@/page/ruan/apply.vue'),
      },
      {
        path: '*',
        redirect: '/incubation-camp',
      },
    ]
  });
  route.beforeEach((to, from, next) => {
    if (to.meta.title) {
      window.document.title = to.meta.title;
    }
    next();
  });
  return route;
}
